import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import { misc } from "app/themes/colors";
import type { AmbientScribe } from "services/types/ambient-scribe.type";

const CHIP_SX = { background: misc.lightGreen };

interface ScribeListRowChipsProps {
  row: AmbientScribe;
  onEdit?: (row: AmbientScribe) => void;
}

/**
 * What the recording holds (Summary / Scribe / Transcript), and Edit when the list offers it.
 */
export default function ScribeListRowChips({
  row,
  onEdit
}: ScribeListRowChipsProps) {
  return (
    <Stack direction="row" justifyContent="space-between">
      {/* Wraps when the list is narrowed on a laptop-width screen (see the dialog's layout
          hook), rather than pushing the row wider than the panel. */}
      <Stack direction="row" columnGap={1.5} rowGap={1} flexWrap="wrap">
        {row.summary && <Chip size="small" label="Summary" sx={CHIP_SX} />}
        {row.soap_notes && <Chip size="small" label="Scribe" sx={CHIP_SX} />}
        {row.transcription && (
          <Chip size="small" label="Transcript" sx={CHIP_SX} />
        )}
      </Stack>
      {onEdit && (
        <Box pl={1} mr={-1} mt={-0.5}>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            sx={{ height: 28, minWidth: 0 }}
            onClick={(e) => {
              e.stopPropagation();
              onEdit(row);
            }}
          >
            Edit
          </Button>
        </Box>
      )}
    </Stack>
  );
}
